// 质检系统
import { lang } from '@public/utils/filters'
export default {
  // 摸型状态
  M_modelStatus: [
    { value: 'NORMAL', label: lang('已上线'), name: lang('已上线') },
    { value: 'ENABLE', label: lang('已下线'), name: lang('已下线') }
  ],
  // 时间类型
  M_timeType: [
    { label: lang('进线时间'), name: lang('进线时间'), value: 0, keyArr: ['sessionStartTimeGe', 'sessionStartTimeLe'] },
    { label: lang('任务创建时间'), name: lang('任务创建时间'), value: 1, keyArr: ['taskCreateTimeGe', 'taskCreateTimeLe'] },
    { label: lang('质检完结时间'), name: lang('质检完结时间'), value: 2, keyArr: ['qtCloseTimeGe', 'qtCloseTimeLe'] }
  ],
  // ID编号类型
  M_numberType: [
    { label: lang('会话ID'), name: lang('会话ID'), value: 0, key: 'sessionIds', getKey: 'numberIds' },
    { label: lang('质检任务ID'), name: lang('质检任务ID'), value: 1, key: 'taskBizIds', getKey: 'numberIds' },
    { label: lang('运单编号'), name: lang('运单编号'), value: 2, key: 'sessionWaybillNos', getKey: 'sessionWaybillNos' },
    { label: lang('工单编号'), name: lang('工单编号'), value: 3, key: 'sessionWoNos', getKey: 'sessionWoNos' }
  ],
  // 组织类型
  M_organizationalType: [
    { label: lang('网点'), name: lang('网点'), value: 'NETWORK' },
    { label: lang('代理区'), name: lang('代理区'), value: 'AGENT_AREA' },
    { label: lang('服务商'), name: lang('服务商'), value: 'BPO' }
  ],
  // 操作类型
  M_operateType: [
    { label: lang('关闭'), name: lang('关闭'), value: 'CLOSE' },
    { label: lang('转单'), name: lang('转单'), value: 'TRANSFER' },
    { label: lang('暂不处理'), name: lang('暂不处理'), value: 'SUSPEND' },
    { label: lang('催单'), name: lang('催单'), value: 'URGE' },
    { label: lang('升级'), name: lang('升级'), value: 'UPGRADE' },
    { label: lang('无'), name: lang('无'), value: 'NONE' }
  ],
  // 挂机方
  M_hangingParty: [
    { label: lang('客户'), name: lang('客户'), value: 'B' },
    { label: lang('客服'), name: lang('客服'), value: 'A' },
    { label: lang('系统'), name: lang('系统'), value: 'R' }
  ],
  // 客户评价
  M_sessionEvalLevel: [
    { label: lang('满意'), name: lang('满意'), value: [3, 4, 5] },
    { label: lang('不满意'), name: lang('不满意'), value: [1, 2] },
    { label: lang('未评价'), name: lang('未评价'), value: [0] }
  ],
  // 是否已质检
  M_WhetherType: [
    { label: lang('是'), name: lang('是'), value: 'YES' },
    { label: lang('否'), name: lang('否'), value: 'NO' }
  ],
  // 命中模型
  M_modelType: [
    { label: lang('首次质检'), name: lang('首次质检'), value: 0, key: 'qtCpHitRuleModelIds' },
    { label: lang('人工复检'), name: lang('人工复检'), value: 1, key: 'qtRcHitRuleModelIds' },
    { label: lang('申诉复检'), name: lang('申诉复检'), value: 2, key: 'qtAppealRcHitRuleModelIds' }
  ],
  // 网点类型
  M_netWorkType: [
    { label: lang('受理网点'), name: lang('受理网点'), value: 0, key: 'sessionNetworkCodes' },
    { label: lang('转单责任网点'), name: lang('转单责任网点'), value: 1, key: 'sessionWoTransferNetworkCodes' }
  ],
  // 代理区类型
  M_agencyType: [
    { label: lang('受理网点代理区'), name: lang('受理网点代理区'), value: 0, key: 'sessionAgencyCodes' },
    { label: lang('转单责任网点所属代理区'), name: lang('转单责任网点所属代理区'), value: 1, key: 'sessionWoTransferAgencyCodes' }
  ],
  // 质检状态
  M_taskStatusType: [
    { label: lang('待分配'), name: lang('待分配'), value: 'RECHECK_ASSIGN_WAITING' },
    { label: lang('待复检'), name: lang('待复检'), value: 'RECHECK_WAITING' },
    { label: lang('已复检'), name: lang('已复检'), value: 'RECHECKED' },
    { label: lang('申诉待分配'), name: lang('申诉待分配'), value: 'APPEAL_RECHECK_ASSIGN_WAITING' },
    { label: lang('申诉待复检'), name: lang('申诉待复检'), value: 'APPEAL_RECHECK_WAITING' },
    { label: lang('申诉已复检'), name: lang('申诉已复检'), value: 'APPEAL_RECHECKED' },
    { label: lang('已完结'), name: lang('已完结'), value: 'CLOSED' }
  ],
  // 是否申诉
  M_qtWhetherAppealType: [
    { label: lang('是'), name: lang('是'), value: 'YES' },
    { label: lang('否'), name: lang('否'), value: 'NO' }
  ],
  // 枚举是否匹配
  M_ifType: {
    YES: lang('是'),
    NO: lang('否')
  },
  // 枚举是否匹配
  M_ifTypeNumber: {
    1: lang('是'),
    2: lang('否')
  },
  // 人工复检结果
  M_retestResults: {
    PASSED: lang('合格'),
    NOT_PASSED: lang('不合格')
  },
  // 通用是否
  M_retestResultsOption: [
    { value: 'PASSED', label: lang('合格'), name: lang('合格') },
    { value: 'NOT_PASSED', label: lang('不合格'), name: lang('不合格') }
  ],
  // 通用是否+全部
  M_retestResultsOptionALL: [
    { value: 'ALL', label: lang('全部'), name: lang('全部') },
    { value: 'PASSED', label: lang('合格'), name: lang('合格') },
    { value: 'NOT_PASSED', label: lang('不合格'), name: lang('不合格') }
  ],
  // 质检类型
  M_retestType: {
    PREVIEW: lang('预览'),
    CP: lang('首次质检'),
    RECHECK: lang('人工复检'),
    APPEAL_RECHECK: lang('申诉复检')
  },
  // 质检类型
  M_qualityType: {
    0: 'PREVIEW', // 预览
    1: 'CP_RECHECKED', // 首次质检
    2: 'RECHECK', // 人工复检
    3: 'APPEAL_RECHECK' // 申诉复检
  },
  // 分配状态
  M_allocationStatus: {
    1: 'ASSIGN_WAITING', // 待分配
    2: 'WAITING', // 等待中
    3: 'COMPLETED' // 已完成
  },
  // 交叉分析
  // 统计方式
  M_statisticalMethods: [
    { value: 1, label: lang('会话量'), name: lang('会话量') },
    { value: 2, label: lang('占比'), name: lang('占比') }
  ],
  // 样式
  M_statisticalStyle: [
    { value: 1, label: lang('柱状图'), name: lang('柱状图') },
    { value: 2, label: lang('饼图'), name: lang('饼图') },
    { value: 3, label: lang('列表'), name: lang('列表') }
  ],
  // 操作类型
  // 是否转单
  M_transferOrder: [
    { value: 'SESSION_NETWORK', label: lang('网点名称'), name: lang('网点名称') },
    { value: 'SESSION_PROVIDER', label: lang('服务商名称'), name: lang('服务商名称') },
    { value: 'TASK_ORG_TYPE', label: lang('组织类型'), name: lang('组织类型') },
    { value: 'SESSION_TIME', label: lang('服务时长'), name: lang('服务时长') },
    { value: 'SESSION_WO_OPERATE_TYPE', label: lang('操作类型'), name: lang('操作类型') },
    { value: 'SESSION_AGENT', label: lang('坐席工号'), name: lang('坐席工号') },
    { value: 'SESSION_AGENCY', label: lang('所属代理区'), name: lang('所属代理区') },
    { value: 'SESSION_WO_TRANSFER_TYPE', label: lang('转单类型'), name: lang('转单类型') }
  ],
  // 工单类型
  M_sessionWoType: [
    { value: 1, label: lang('普通工单'), name: lang('普通工单') },
    { value: 2, label: lang('理赔工单'), name: lang('理赔工单') },
    { value: 3, label: lang('平台工单'), name: lang('平台工单') },
    { value: 4, label: lang('问题记录'), name: lang('问题记录') },
    { value: 5, label: lang('邮政工单'), name: lang('邮政工单') }
  ],
  isDownUp: [
    { value: 'NORMAL', label: lang('是'), name: lang('是') },
    { value: 'ENABLE', label: lang('否'), name: lang('否') }
  ],
  // 质检类型
  isQualityType: [
    { value: 'IM', label: lang('在线质检'), name: lang('在线质检') },
    { value: 'CC', label: lang('语音质检'), name: lang('语音质检') },
    { value: 'WO', label: lang('工单质检'), name: lang('工单质检') }
  ],
  // 干线状态
  shipmentState: [
    { value: 0, label: lang('待调度'), name: lang('待调度') },
    { value: 1, label: lang('已调度'), name: lang('已调度') },
    { value: 2, label: lang('待执行'), name: lang('待执行') },
    { value: 3, label: lang('在途'), name: lang('在途') },
    { value: 4, label: lang('已完成'), name: lang('已完成') },
    { value: 5, label: lang('已作废'), name: lang('已作废') }
  ],
  // 质检对象
  isQualityObject: [
    { value: 'AGENT', label: lang('客服'), name: lang('客服') },
    { value: 'RABBIT_YODA', label: lang('兔优达-派件员'), name: lang('兔优达-派件员') }
  ],
  isQualityObjectNew: [
    { value: 1, label: lang('客服'), name: lang('客服') },
    { value: 2, label: lang('兔优达-派件员'), name: lang('兔优达-派件员') }
  ],
  // 工单类型
  WO_TYPE: [
    { value: 'WORK_ORDER', label: lang('普通工单'), name: lang('普通工单') },
    { value: 'CLAIM_ORDER', label: lang('理赔工单'), name: lang('理赔工单') },
    { value: 'PW_ORDER', label: lang('平台工单'), name: lang('平台工单') },
    { value: 'PROBLEM_ORDER', label: lang('问题记录'), name: lang('问题记录') },
    { value: 'POSTAL_ORDER', label: lang('邮政工单'), name: lang('邮政工单') },
    { value: 'APPEAL_INFO', label: lang('邮政申诉工单'), name: lang('邮政申诉工单') },
    { value: 'COMPLAINT_INFO', label: lang('邮政投诉工单'), name: lang('邮政投诉工单') },
    { value: 'OFFLINE_COMPLAINT', label: lang('邮政线下工单'), name: lang('邮政线下工单') }
  ],
  // 工单来源
  WO_SOURCE: [
    { value: 'SITE', label: lang('网点组'), name: lang('网点组') },
    { value: 'AGENT', label: lang('代理组'), name: lang('代理组') },
    { value: 'HEADQUARTERS', label: lang('总部组'), name: lang('总部组') },
    { value: 'TELEPHONE', label: lang('电话组别'), name: lang('电话组别') },
    { value: 'HEADQUARTERS_WORKORDER', label: lang('总部工单组'), name: lang('总部工单组') },
    { value: 'HEADQUARTERS_CLAIM', label: lang('总部理赔组'), name: lang('总部理赔组') },
    { value: 'MERCHANT', label: lang('平台'), name: lang('平台') },
    { value: 'CUSTOMER', label: lang('消费者'), name: lang('消费者') },
    { value: 'PLATFORM', label: lang('商家'), name: lang('商家') },
    { value: 'POSTAL', label: lang('邮政'), name: lang('邮政') }
  ],
  // 工单来源-普通工单
  WO_SOURCE_LP: [
    { value: 'SITE', label: lang('网点组'), name: lang('网点组') },
    { value: 'AGENT', label: lang('代理组'), name: lang('代理组') },
    { value: 'HEADQUARTERS', label: lang('总部组'), name: lang('总部组') },
    { value: 'TELEPHONE', label: lang('电话组别'), name: lang('电话组别') },
    { value: 'HEADQUARTERS_WORKORDER', label: lang('总部工单组'), name: lang('总部工单组') },
    { value: 'HEADQUARTERS_CLAIM', label: lang('总部理赔组'), name: lang('总部理赔组') },
    { value: 'POSTAL', label: lang('邮政'), name: lang('邮政') }
  ],
  // 工单来源-平台工单
  WO_SOURCE_PT: [
    { value: 'MERCHANT', label: lang('平台'), name: lang('平台') },
    { value: 'CUSTOMER', label: lang('消费者'), name: lang('消费者') },
    { value: 'PLATFORM', label: lang('商家'), name: lang('商家') }
  ],
  // 工单渠道
  WO_CHANNEL: [
    { value: 'PDD', label: lang('桃花岛'), name: lang('桃花岛') },
    { value: 'TIKTOK', label: lang('紫金山'), name: lang('紫金山') },
    { value: 'CAI_NIAO', label: lang('七星潭'), name: lang('七星潭') },
    { value: 'RED_BOOK', label: lang('小红书'), name: lang('小红书') },
    { value: 'TAO_BAO', label: lang('淘天'), name: lang('淘天') },
    { value: 'JING_DONG', label: lang('极地湾'), name: lang('极地湾') }
  ],
  WO_ISENABLE: [
    { value: 'ENABLE', label: lang('禁用'), name: lang('禁用') },
    { value: 'NORMAL', label: lang('启用'), name: lang('启用') }
  ],
  // 留言类型
  leaveMessageType: [
    { value: 1, label: lang('破损'), name: lang('破损') },
    { value: 2, label: lang('延误'), name: lang('延误') },
    { value: 3, label: lang('遗失'), name: lang('遗失') },
    { value: 4, label: lang('其他'), name: lang('其他') },
    { value: 5, label: lang('退转'), name: lang('退转') },
    { value: 6, label: lang('漏录签收'), name: lang('漏录签收') }
  ]
}
